import React, { Fragment } from 'react'
import styles from './BBKVKProductTemplate.module.css'

import {
  TextField,
  FormControl,
  FormLabel,
  MenuItem,
  IconButton,
  Typography,
} from '@material-ui/core'
//import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Icon from '@material-ui/core/Icon'

import WettenPanel from './WettenPanel.js'

import AbstractArea from '../../../AbstractArea'

export default class BBKVKProductTemplate extends AbstractArea {
  state = { openWetten: false, areas: [], defaultValues: false }

  handleButtonClick = (uri, productUri, index) => {
    //selection
    if (this.props.publishVariable != null) {
      this.props.publish(this.props.publishVariable, uri)
    }
    // wat gaan we veranderen

    this.setState({
      selectedUri: uri,
      selectedProductUri: productUri,
      openWetten: true,
      openIndex: index,
    })
  }

  handleCloseWetten = (value) => {
    this.setState({ openWetten: false, openIndex: -1 })
  }

  /*BUTTON: "button"
CHECKBOX: "checkbox"
DATE_PICKER: "date-picker"
DUAL_LIST_SELECT: "dual-list-select"
FIELD_ARRAY: "field-array"
INPUT_ADDON_BUTTON_GROUP: "input-addon-button-group"
INPUT_ADDON_GROUP: "input-addon-group"
PLAIN_TEXT: "plain-text"
RADIO: "radio"
SELECT: "select"
SLIDER: "slider"
SUB_FORM: "sub-form"
SWITCH: "switch"
TABS: "tabs"
TAB_ITEM: "tab-item"
TEXTAREA: "textarea"
TEXT_FIELD: "text-field"
TIME_PICKER: "time-picker"
WIZARD: "wizard"
*/

  static getDescription() {
    return {
      name: 'BBKVKProductTemplate',
      component: BBKVKProductTemplate,
      label: 'BBK KVK Product Template',
      variables: [
        {
          name: 'title',
          type: 'text',
          label: 'Titel boven de template',
        },
        {
          name: 'query',
          type: 'yasgui',
          label:
            'to fill the form. Use title,uri, propUri, label,value, type (xsd,select), optionLabel optionValue ?required regex, multiple,objectOfCls ',
        },
        {
          name: 'buttons',
          type: 'array',
          label: 'buttons',
        },
        {
          name: 'popupFullScreen',
          type: 'array',
          label: 'popupFullScreen',
        },
        {
          name: 'popupTitle',
          type: 'array',
          label: 'popupTitle',
        },
        {
          name: 'publishVariable',
          type: 'text',
          label: 'Variabele in which URI is published when button is clicked.',
        },

        {
          name: 'className',
          type: 'text',
          label: 'iframe classNames',
        },
      ],
    }
  }

  toggleDefaultValues() {
    let defaultValues = !this.state.defaultValues
    this.setState({ defaultValues: defaultValues })
  }
  onChange() {
    console.log('onChange')
  }
  onSelectChange(id, ev) {
    try {
      console.log(id, ev.target.value)
      var o = {}
      o[id] = ev.target.value

      this.setState(o)
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    if (this.props.data == null) {
      return null
    }
    if (this.props.data.results == null) {
      return null
    }
    let title = this.props.title
    if (title == null) {
      title = ''
    }
    let bindings = this.props.data.results.bindings
    try {
      title = bindings[0].title.value
    } catch (eeer) {}
    let selectedUri = this.state.selectedUri
    let key = 1
    let areas = []
    if (this.props.areas != null) {
      areas = this.props.areas
    } else {
    }

    var buttons = this.props.buttons
    if (buttons == null) {
      buttons = []
    }

    let productLogo = '/logos/kvkuittreksel.png'
    if (bindings.length === 0) {
      productLogo = '/logos/kvkproduct.png'
    }
    let previousLabelHeader = null
    return (
      <FormControl>
        <div className={styles.outer}>
          <div className={styles.inner}>
            <img src={productLogo}></img>{' '/*eslint-disable-line jsx-a11y/alt-text*/}
            <Typography className={styles.productTitle} variant="">
              {' '}
              {title}{' '}
            </Typography>{' '}
            <IconButton
              className={styles.defaultValueButton}
              onClick={() => this.toggleDefaultValues()}
              aria-label="delete"
              size="small"
            >
              {' '}
              <Icon>info</Icon>
            </IconButton>
            {bindings.map((binding) => {
              key++
              //var binding =bindings[key];
              let uri = binding.uri.value

              let element = 'niets'
              try {
                element = binding.element.value
              } catch (e) {}
              let defaultValue = ''
              try {
                defaultValue = binding.defaultValue.value
              } catch (e) {}
              if (this.state.defaultValues !== true) {
                defaultValue = ''
              }
              let label = binding.label.value
              let header = true
              let labelHeader = binding.labelHeader.value
              if (labelHeader === previousLabelHeader) {
                header = false
              }
              previousLabelHeader = labelHeader
              let optionsS = null
              try {
                optionsS = binding.options.value
              } catch (e) {}
              let options = []
              if (optionsS != null) {
                options = optionsS.split(';')
              }

              //
              if (label == null) {
                label = 'error'
              }
              // for optoins
              var valueS = this.state[element]
              if (valueS == null) {
                valueS = defaultValue
              }
              var textOnly = false
              try {
                textOnly = binding.textOnly.value
                if (textOnly === 'true') {
                  textOnly = true
                } else {
                  textOnly = false
                }
              } catch (e) {}

              return (
                <Fragment>
                  {header && (
                    <div key={'header' + key}>
                      <br></br>
                      <br></br>
                      <Typography variant="h6"> {labelHeader} </Typography>
                    </div>
                  )}
                  <div key={'div' + key} className={styles.divtext}>
                    <br></br>{' '}
                    <div>
                      {textOnly ? (
                        <FormLabel>{label}</FormLabel>
                      ) : (
                        <Fragment>
                          {' '}
                          {optionsS == null ? (
                            <TextField
                              key={'textfield' + key}
                              className={styles.textfield2}
                              label={label}
                              value={defaultValue}
                            >
                              {' '}
                            </TextField>
                          ) : (
                            <Fragment>
                              <TextField
                                select
                                label={label}
                                value={valueS}
                                onChange={(value) => {
                                  this.onSelectChange(element, value)
                                }}
                                key={element}
                                name={element}
                                className={styles.textfield2}
                              >
                                {options.map((name) => (
                                  <MenuItem key={name} value={name}>
                                    {name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Fragment>
                          )}
                        </Fragment>
                      )}

                      <div key={'buttonDiv' + key} className={styles.buttonDiv}>
                        {buttons.map((button, index) => {
                          //return (<Button className={styles.button2}  key={"button"+index} onClick={() =>this.handleClickOpenWetten(element,uri,index)}  size="small" variant="contained"  className={styles.linkbutton} >{button}</Button>       );
                          return (
                            <IconButton
                              onClick={() =>
                                this.handleButtonClick(element, uri, index)
                              }
                              key={'button' + index}
                              aria-label="delete"
                              size="small"
                            >
                              {' '}
                              <Icon>{button}</Icon>{' '}
                            </IconButton>
                          )
                        })}
                      </div>
                    </div>{' '}
                  </div>
                </Fragment>
              )
            })}
            {buttons.map((button, index) => {
              let areaConfig = areas[index] || {}
              var open = false
              let title = 'geen title'
              try {
                title = this.props.popupTitle[index]
              } catch (e) {}

              let fullScreen = true
              try {
                fullScreen = this.props.popupFullScreen[index]
              } catch (e) {}

              if (index === this.state.openIndex) {
                open = true
              }
              //  console.log(open);
              return (
                <WettenPanel
                  title={title}
                  fullScreen={fullScreen}
                  index={index}
                  onChange={this.onChange}
                  key={'wettenpanel' + index}
                  {...this.props}
                  config={areaConfig}
                  open={open}
                  uri={selectedUri}
                  onClose={this.handleCloseWetten}
                />
              )
            })}
          </div>
        </div>
      </FormControl>
    )
  }
}
